import SharedDrivesAdminGridWithTree from './shared-drives-admin-grid-with-tree';
import { pagesConfig } from '../../../shared/pages-config';
import ChangeLogDialog from '../../../shared/change-log-dialog';
import { useChangeLogGate } from '../../../shared/hooks/use-change-log-gate';
import { useUserSettings } from '../../../utils/use-user-settings';
import { DriveRoles } from '../../../utils/roles/client-roles';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function SharedDrivesPage() {
  const { driveRoles, changeLogRoles, primaryDomain, loggedInUser } =
    useUserSettings();

  const changeLogGate = useChangeLogGate({
    permissionValue: DriveRoles.ViewSharedDrives.value,
    changeLogRoles,
  });

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.drive.name },
        { label: pagesConfig.sharedDrives.name },
      ]}
      bookmarkKey={pagesConfig.sharedDrives.value}
    >
      <>
        {changeLogGate.needsChangeLog ? (
          <ChangeLogDialog
            open={changeLogGate.openChangeLogDialog}
            handleClose={changeLogGate.dismiss}
            changeLogMessage={changeLogGate.changeLogMessage}
            setChangeLogMessage={changeLogGate.setChangeLogMessage}
            mutate={changeLogGate.confirm}
            mutateLoading={false}
          />
        ) : null}
        <SharedDrivesAdminGridWithTree
          loggedInUser={loggedInUser}
          primaryDomain={primaryDomain}
          driveRoles={driveRoles}
          changeLogRoles={changeLogRoles}
          canFetch={changeLogGate.canFetch}
          confirmedChangeLogMessage={changeLogGate.confirmedChangeLogMessage}
          showChangeLogOverlay={
            changeLogGate.needsChangeLog && !changeLogGate.canFetch
          }
          onOpenChangeLogDialog={changeLogGate.openDialog}
        />
      </>
    </SimpleBreadcrumbsPage>
  );
}
